var defaultStyles = {
  "root": "Base-Drawer",
  "wrapper": "Base-Drawer--Wrapper",
  "mask": "Base-Drawer--Mask",
  "inner": "Base-Drawer--Inner",
  "header": "Base-Drawer--Header",
  "content": "Base-Drawer--Content",
  "footer": "Base-Drawer--Footer",
  "nofooter": "Base-Drawer--Nofooter",
  "noheader": "Base-Drawer--Noheader",
  "title": "Base-Drawer--Title",
  "button": "Base-Drawer--Button",
  "close": "Base-Drawer--Close"
};

export { defaultStyles as default };
